export default {
  methods: {
    clearPostType() {
      this.$emit('clear-post-type');
    },
  },
};
